import { render, staticRenderFns } from "./charmDetail.vue?vue&type=template&id=195b9c6a"
import script from "./charmDetail.vue?vue&type=script&lang=js"
export * from "./charmDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('195b9c6a')) {
      api.createRecord('195b9c6a', component.options)
    } else {
      api.reload('195b9c6a', component.options)
    }
    module.hot.accept("./charmDetail.vue?vue&type=template&id=195b9c6a", function () {
      api.rerender('195b9c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/charmDetail.vue"
export default component.exports